import { Companion_instance1ws7d9j63nohl as Companion_instance } from '../../../../../../okio-parent-okio/okio/HashingSink.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../okio-parent-okio/okio/Okio.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../json/JsonWriters.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { urlEncoded5v8jd8by0u4 as urlEncode } from './internal/UrlEncode.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  HttpHeader1d7ldebjomr00 as HttpHeader,
  get3c0ofj2dgi8ma as get,
  HttpMethod_Post_getInstanceu6nxq43savnq as HttpMethod_Post_getInstance,
  HttpMethod_Get_getInstance32yh63ksulkub as HttpMethod_Get_getInstance,
  Builder2ocxamygt14i4 as Builder,
} from './Http.mjs';
import {
  toRequestParameters3ovu7e0943da8 as toRequestParameters,
  toMap14rbdrx2whbk6 as toMap,
  toHttpBody2x6lfaxkoi6pf as toHttpBody,
} from '../RequestParameters.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Query2hw717wsl0l5r as Query } from '../Query.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { CacheUrlOverride1zltsak657aw6 as CacheUrlOverride } from './CacheUrlOverride.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { add2suhfggl4zvkk as add } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function sha256($this, $receiver) {
  var hashingSink = Companion_instance.g3x(blackholeSink());
  var buffer_0 = buffer(hashingSink);
  writeAny(new (BufferedSinkJsonWriter())(buffer_0), $receiver);
  buffer_0.oc();
  return hashingSink.j3x().g3v();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.y47_1 = 'Apollo-Require-Preflight';
        this.z47_1 = 'Accept';
        this.a48_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
        this.b48_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
      }
      c48(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1(_this__u8e3s4);
        var hasQuestionMark = contains(_this__u8e3s4, '?');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = parameters.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (hasQuestionMark) {
            this_0.o1(_Char___init__impl__6a9atx(38));
          } else {
            hasQuestionMark = true;
            this_0.o1(_Char___init__impl__6a9atx(63));
          }
          this_0.m1(urlEncode(element.m3()));
          this_0.o1(_Char___init__impl__6a9atx(61));
          this_0.m1(urlEncode(element.n3()));
        }
        return this_0.toString();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var DefaultHttpRequestComposerClass;
function DefaultHttpRequestComposer() {
  if (DefaultHttpRequestComposerClass === VOID) {
    class $ {
      constructor(serverUrl, enablePostCaching) {
        return new.target.f48(serverUrl, enablePostCaching);
      }
      static f48(serverUrl, enablePostCaching) {
        var $this = createThis(this);
        $this.d48_1 = serverUrl;
        $this.e48_1 = enablePostCaching;
        return $this;
      }
      static g48(serverUrl) {
        return this.f48(serverUrl, false);
      }
      h48(apolloRequest) {
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().p2();
        if (!(apolloRequest.a41_1 == null)) {
          this_0.u2(apolloRequest.a41_1);
        }
        if (get(this_0, 'accept') == null) {
          var tmp;
          var tmp_0 = apolloRequest.t40_1;
          if (isInterface(tmp_0, Subscription())) {
            tmp = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
          } else {
            tmp = 'application/graphql-response+json, application/json';
          }
          this_0.j2(new (HttpHeader())('accept', tmp));
        }
        var requestHeaders = this_0;
        var requestParameters = toRequestParameters(apolloRequest);
        var tmp0_elvis_lhs = apolloRequest.y40_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.d48_1 : tmp0_elvis_lhs;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = "ApolloRequest.url is missing for request '" + apolloRequest.t40_1.operationName() + "', did you call ApolloClient.Builder.serverUrl(url)?";
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var url = tmp_1;
        var tmp2_elvis_lhs = apolloRequest.z40_1;
        var tmp_2;
        switch ((tmp2_elvis_lhs == null ? HttpMethod_Post_getInstance() : tmp2_elvis_lhs).w1_1) {
          case 0:
            tmp_2 = (new (Builder())(HttpMethod_Get_getInstance(), Companion_instance_0.c48(url, asGetParameters(toMap(requestParameters))))).n48('Apollo-Require-Preflight', 'true');
            break;
          case 1:
            var body = toHttpBody(requestParameters);
            // Inline function 'kotlin.apply' call

            var this_1 = new (Builder())(HttpMethod_Post_getInstance(), url);
            this_1.o48(body);
            if (startsWith(body.t47(), 'multipart/form-data')) {
              this_1.n48('Apollo-Require-Preflight', 'true');
            }

            var operation = apolloRequest.t40_1;
            var tmp_3;
            if (this.e48_1) {
              tmp_3 = isInterface(operation, Query());
            } else {
              tmp_3 = false;
            }

            if (tmp_3) {
              // Inline function 'kotlin.collections.mutableMapOf' call
              var cacheParameters = LinkedHashMap().ec();
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!requestParameters.i47_1.n1()) {
                cacheParameters.a5('variablesHash', sha256(this, requestParameters.i47_1));
              }
              cacheParameters.a5('operationName', operation.operationName());
              cacheParameters.a5('operationId', operation.operationId());
              this_1.w41(new (CacheUrlOverride())(Companion_instance_0.c48(url, cacheParameters)));
            }

            tmp_2 = this_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var httpRequestBuilder = tmp_2;
        return httpRequestBuilder.p48(requestHeaders).w41(apolloRequest.x40_1).j37();
      }
    }
    initMetadataForClass($, 'DefaultHttpRequestComposer');
    DefaultHttpRequestComposerClass = $;
  }
  return DefaultHttpRequestComposerClass;
}
function asGetParameters(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().fc(mapCapacity(_this__u8e3s4.q2()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = _this__u8e3s4.l3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = element.m3();
    var v = element.n3();
    var tmp_0;
    if (!(v == null) ? typeof v === 'string' : false) {
      tmp_0 = v;
    } else {
      // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
      var buffer = new (Buffer())();
      var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
      writeAny($this$buildJsonString, v);
      tmp_0 = buffer.l3w();
    }
    var tmp$ret$4 = tmp_0;
    destination.a5(tmp, tmp$ret$4);
  }
  return destination;
}
function buildUploadMap($this, uploads) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = uploads.l3();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().i2(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$4 = to(index_0.toString(), listOf(item.m3()));
    destination.j2(tmp$ret$4);
  }
  writeAny($this$buildJsonByteString, toMap_0(destination));
  return buffer.h3w();
}
function writeBoundaries($this, $receiver, writeUploadContents) {
  $receiver.v3w('--' + $this.s48_1 + '\r\n');
  $receiver.v3w('Content-Disposition: form-data; name="operations"\r\n');
  $receiver.v3w('Content-Type: application/json\r\n');
  $receiver.v3w('Content-Length: ' + $this.r48_1.q2() + '\r\n');
  $receiver.v3w('\r\n');
  $receiver.t3w($this.r48_1);
  var uploadsMap = buildUploadMap($this, $this.q48_1);
  $receiver.v3w('\r\n--' + $this.s48_1 + '\r\n');
  $receiver.v3w('Content-Disposition: form-data; name="map"\r\n');
  $receiver.v3w('Content-Type: application/json\r\n');
  $receiver.v3w('Content-Length: ' + uploadsMap.q2() + '\r\n');
  $receiver.v3w('\r\n');
  $receiver.t3w(uploadsMap);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = $this.q48_1.z4().p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    $receiver.v3w('\r\n--' + $this.s48_1 + '\r\n');
    $receiver.v3w('Content-Disposition: form-data; name="' + index_0 + '"');
    if (!(item.w47() == null)) {
      $receiver.v3w('; filename="' + item.w47() + '"');
    }
    $receiver.v3w('\r\n');
    $receiver.v3w('Content-Type: ' + item.t47() + '\r\n');
    var contentLength = item.u47();
    if (!(contentLength === -1n)) {
      $receiver.v3w('Content-Length: ' + contentLength.toString() + '\r\n');
    }
    $receiver.v3w('\r\n');
    if (writeUploadContents) {
      item.v47($receiver);
    }
  }
  $receiver.v3w('\r\n--' + $this.s48_1 + '--\r\n');
}
function UploadsHttpBody$_get_contentLength_$ref_e5o4rd() {
  return constructCallableReference((p0) => p0.u47(), 1, 0, 204);
}
var UploadsHttpBodyClass;
function UploadsHttpBody() {
  if (UploadsHttpBodyClass === VOID) {
    class $ {
      constructor(uploads, operationByteString) {
        this.q48_1 = uploads;
        this.r48_1 = operationByteString;
        this.s48_1 = uuid4().toString();
        this.t48_1 = 'multipart/form-data; boundary=' + this.s48_1;
        var tmp = this;
        tmp.u48_1 = lazy(() => {
          var countingSink = new (CountingSink())(blackholeSink());
          var bufferedCountingSink = buffer(countingSink);
          writeBoundaries(this, bufferedCountingSink, false);
          bufferedCountingSink.oc();
          var tmp = countingSink.w48_1;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0n;
          var _iterator__ex2g4s = this.q48_1.z4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_0 = sum;
            var tmp$ret$1 = element.u47();
            sum = add(tmp_0, tmp$ret$1);
          }
          var tmp$ret$0 = sum;
          var result = add(tmp, tmp$ret$0);
          return result;
        });
      }
      t47() {
        return this.t48_1;
      }
      u47() {
        var tmp0 = this.u48_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('contentLength', 1, tmp, UploadsHttpBody$_get_contentLength_$ref_e5o4rd(), null);
        return tmp0.n3();
      }
      v47(bufferedSink) {
        writeBoundaries(this, bufferedSink, true);
      }
    }
    initMetadataForClass($, 'UploadsHttpBody');
    UploadsHttpBodyClass = $;
  }
  return UploadsHttpBodyClass;
}
var CountingSinkClass;
function CountingSink() {
  if (CountingSinkClass === VOID) {
    class $ {
      constructor(delegate) {
        this.v48_1 = delegate;
        this.w48_1 = 0n;
      }
      j3s(source, byteCount) {
        this.v48_1.j3s(source, byteCount);
        this.w48_1 = add(this.w48_1, byteCount);
      }
      oc() {
        this.v48_1.oc();
      }
      l6() {
        this.v48_1.l6();
      }
    }
    initMetadataForClass($, 'CountingSink');
    CountingSinkClass = $;
  }
  return CountingSinkClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  DefaultHttpRequestComposer as DefaultHttpRequestComposer3cbqxfvy17yg2,
  UploadsHttpBody as UploadsHttpBody13sq2iwgyese9,
};
//endregion

//# sourceMappingURL=DefaultHttpRequestComposer.mjs.map
